import React from 'react';
import Email from '../../../../components/Email';
import Url from '../../../../components/Url';
import {
  Annotation,
  Paragraph,
  Title,
  ListNumber,
  ListItem
} from './PrivacyPolicyContent.styled';

const PrivacyPolicyContent = () => (
  <>
    <Paragraph>
      <strong>ProteGO Safe</strong>
    </Paragraph>
    <Paragraph>
      <strong>Najistotniejsze informacje dotyczące Twojej prywatności</strong>
    </Paragraph>
    <Paragraph>
      Przygotowaliśmy ten dokument, aby poinformować Cię jak przetwarzamy
      informacje i dane w ProteGO Safe, a także jakie prawa Ci przysługują.
      Poniżej znajdziesz kluczowe informacje związane z przetwarzaniem danych i
      informacji w ramach naszej Aplikacji.
    </Paragraph>
    <Paragraph>
      Zaprojektowaliśmy ProteGO Safe zgodnie z zasadami Privacy by Default oraz
      Privacy by Design. Oznacza to, że domyślnie stosujemy ochronę Twojej
      prywatności i staraliśmy się ograniczyć przetwarzanie Twoich danych już na
      etapie projektowania i tworzenia aplikacji ProteGO Safe. Staramy się nie
      pozyskiwać od Ciebie informacji, które umożliwią Twoją identyfikację (tj.
      danych osobowych), ale może się zdarzyć tak, że podczas korzystania z
      Aplikacji podasz nam tyle informacji, że będziemy w stanie Cię
      zidentyfikować (nawet pośrednio) – oznacza to, że będziemy administratorem
      Twoich danych.
    </Paragraph>
    <Paragraph>
      <u>
        Przetwarzane Dane Osobowe nie są udostępniane nikomu w formie, która
        pozwalałaby na identyfikację Ciebie.
      </u>{' '}
      Nie będziemy mieli dostępu do informacji i danych osobowych, które
      wprowadzisz do aplikacji ProteGO Safe. Nie będziemy podejmowali aktywnych
      działań, aby Cię zidentyfikować. Nie będziemy także analizowali jak
      korzystasz z ProteGO Safe.
    </Paragraph>
    <Paragraph>
      Informacje wprowadzone do ProteGO Safe związane z samooceną ryzyka
      infekcji wirusem SARS-CoV-2 będą w sposób zanonimizowany przesłane do
      Infermedica. Infermedica także nie będzie miała możliwości
      zidentyfikowania Cię.
    </Paragraph>
    <Annotation>§1.</Annotation>
    <Title>Postanowienia ogólne</Title>
    <ListNumber>
      <ListItem>
        Niniejsza Polityka Prywatności określa zasady zbierania, przetwarzania i
        ochrony Danych Osobowych w związku z korzystaniem z aplikacji ProteGO
        Safe.
      </ListItem>
      <ListItem>
        Niniejszy dokument jest przygotowany w oparciu o postanowienia
        Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27
        kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z
        przetwarzaniem Danych Osobowych i w sprawie swobodnego przepływu takich
        danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o
        ochronie danych), ustawy z dnia 10 maja 2018 r. o ochronie Danych
        Osobowych (Dz.U. z 2018 r. poz. 1000) oraz innych przepisów powszechnie
        obowiązujących.
      </ListItem>
      <ListItem>
        Administratorem Danych Użytkowników jest Główny Inspektor Sanitarny z
        siedzibą w Warszawie, ul. Targowa 65, 03–729 Warszawa.
      </ListItem>
      <ListItem>
        W razie ogólnych pytań dotyczących prywatności, a także pytań
        dotyczących niniejszej Polityki prywatności lub wykorzystania Danych
        Osobowych zachęcamy do kontaktu pod adresem:{' '}
        <Email>protego@mc.gov.pl</Email> lub <Email>iod@gis.gov.pl</Email>.
      </ListItem>
      <ListItem>
        Administrator Danych powołał inspektora ochrony danych. Z inspektorem
        ochrony danych można kontaktować się we wszystkich sprawach dotyczących
        przetwarzania danych osobowych przez Administratora Danych oraz
        korzystania z praw związanych z przetwarzaniem tych danych. Inspektorem
        Ochrony Danych jest Renata Wągrodzka z którą możesz skontaktować się za
        pośrednictwem adresu e-mail: <Email>iod@gis.gov.pl</Email>.
      </ListItem>
      <ListItem>
        Administrator Danych zapewnia, iż dokłada wszelkich starań, by
        Przetwarzanie przez niego Danych Osobowych odbywało się z największym
        poszanowaniem prywatności osób, których dane dotyczą oraz z najwyższą
        dbałością o bezpieczeństwo przetwarzanych Danych Osobowych, a w
        szczególności zapewnia, iż podjął wszelkie przewidziane prawem środki
        zmierzające do zabezpieczenia zbiorów Danych Osobowych.
      </ListItem>
      <ListItem>
        Administrator Danych oświadcza, iż stosuje środki techniczne i
        organizacyjne zapewniające ochronę przetwarzanych Danych Osobowych
        odpowiednią do zagrożeń oraz kategorii danych objętych ochroną, a w
        szczególności zabezpiecza dane przed ich udostępnieniem osobom
        nieupoważnionym, zabraniem przez osobę nieuprawnioną, przetwarzaniem z
        naruszeniem prawa oraz zmianą, utratą, uszkodzeniem lub zniszczeniem.
      </ListItem>
    </ListNumber>
    <Annotation>§2.</Annotation>
    <Title>Definicje</Title>
    <Paragraph>Ilekroć w Polityce Prywatności mowa o:</Paragraph>
    <ListNumber>
      <ListItem>
        <strong>Administratorze Danych</strong> – rozumie się przez to Głównego
        Inspektora Sanitarnego z siedzibą w Warszawie, ul. Targowa 65, 03–729
        Warszawa. Administrator Danych samodzielnie ustala cele i sposoby
        przetwarzania Danych Osobowych.
      </ListItem>
      <ListItem>
        <strong>Danych Osobowych</strong> – rozumie się przez to podstawowe dane
        o Użytkowniku, tj. nazwa Użytkownika oraz inne dane podawane podczas
        korzystania z ProteGO Safe i określone w niniejszej Polityce
        Prywatności, dzięki którym możliwe jest określenie tożsamości w sposób
        bezpośredni lub pośredni;
      </ListItem>
      <ListItem>
        <strong>ProteGO Safe lub Aplikacja</strong> – rozumie się przez to
        aplikację ProteGO Safe, która umożliwia triaż (samoocenę ryzyka infekcji
        wirusem SARS-CoV-2, stworzoną na podstawie kwestionariusza WHO),
        dziennik zdrowia Użytkownika, wsparcie w profilaktyce i zapobieganiu
        zarażeniem, wczesne ostrzeganie Użytkownika potencjalnie zagrożonego
        zarażeniem, informowanie o istotnych informacjach związanych z pandemią
        wirusa SARS-CoV-2 oraz przypominacz bezpiecznych zachowań i nawyków
        codziennej higieny;
      </ListItem>
      <ListItem>
        <strong>Przetwarzaniu </strong>– rozumie się przez to operację lub
        zestaw operacji wykonywanych na Danych Osobowych lub zestawach Danych
        Osobowych w sposób zautomatyzowany lub niezautomatyzowany, taką jak
        zbieranie, utrwalanie, organizowanie, porządkowanie, przechowywanie,
        adaptowanie lub modyfikowanie, pobieranie, przeglądanie,
        wykorzystywanie, ujawnianie poprzez przesłanie, rozpowszechnianie lub
        innego rodzaju udostępnianie, dopasowywanie lub łączenie, ograniczanie,
        usuwanie lub niszczenie;
      </ListItem>
      <ListItem>
        <strong>Regulaminie</strong> – rozumie się przez to dokument, który
        określa warunki korzystania z ProteGO Safe, a także prawa i obowiązki
        Administratora Danych oraz Użytkowników;
      </ListItem>
      <ListItem>
        <strong>RODO</strong> – rozumie się przez to Rozporządzenia Parlamentu
        Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie
        ochrony osób fizycznych w związku z przetwarzaniem Danych Osobowych i w
        sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy
        95/46/WE (ogólne rozporządzenie o ochronie danych);
      </ListItem>
      <ListItem>
        <strong>Urządzeniu</strong> – rozumie się przez to elektroniczne
        Urządzenie za pośrednictwem, którego Użytkownik uzyskuje dostęp do
        ProteGO Safe (tablet, smartphone itp.) z systemem Android 5.0 lub
        wyższym z dostępem do sklepu Google Play albo z systemem iOS w wersji
        nie niższej niż 12.1 z dostępem do sklepu AppStore;
      </ListItem>
      <ListItem>
        <strong>Użytkowniku</strong> – rozumie się przez to osobę (Ciebie),
        która zgodnie z Regulaminem i przepisami prawa korzysta z ProteGO Safe;
      </ListItem>
      <ListItem>
        <strong>WHO</strong> - rozumie się przez to Światową Organizację Zdrowia
        (World Health Organisation);
      </ListItem>
    </ListNumber>
    <Annotation>§3.</Annotation>
    <Title>Ogólne zasady Przetwarzania Danych Osobowych</Title>
    <ListNumber>
      <ListItem>
        Dane Osobowe przetwarzane są wyłącznie w następujących celach:
        <ListNumber>
          <ListItem>przeciwdziałania pandemii wirusa SARS-CoV-2;</ListItem>
          <ListItem>
            profilowanie w celu przeciwdziałania pandemii wirusa SARS-CoV-2
          </ListItem>
          <ListItem>
            korzystania przez Użytkownika z Aplikacji zgodnie z Regulaminem;
          </ListItem>
          <ListItem>analiza, organizowanie i ulepszanie ProteGO Safe.</ListItem>
        </ListNumber>
      </ListItem>
      <ListItem>
        Dane Osobowe osób, których dane dotyczą, są przetwarzane na podstawie{' '}
        <strong>art. 6 ust. 1 lit. c RODO</strong> w zw. z zadaniem publicznym
        polegającym na zapobieganiu, przeciwdziałaniu i zwalczaniu{' '}
        <Url value="https://www.gov.pl/web/koronawirus">COVID-19</Url>{' '}
        wynikającym z art. 1, 2, 3, 6 oraz 8a ust. 1, 4 i 5 ustawy z dnia 14
        marca 1985 r o Państwowej Inspekcji Sanitarnej (Dz.U. z 2019 r. poz.
        59).
      </ListItem>
      <ListItem>
        Dane Osobowe dotyczące stanu zdrowia Użytkownika są przetwarzane także
        na podstawie <strong>art. 9 ust. 2 lit. i RODO </strong>w zw. z zadaniem
        publicznym polegającym na zapobieganiu, przeciwdziałaniu i zwalczaniu{' '}
        <Url value="https://www.gov.pl/web/koronawirus">COVID-19</Url>{' '}
        wynikającym z art. 1, 2, 3, 6 oraz 8a ust. 1, 4 i 5 ustawy z dnia 14
        marca 1985 r o Państwowej Inspekcji Sanitarnej (Dz.U. z 2019 r. poz.
        59), gdyż przetwarzanie jest niezbędne ze względów związanych z
        interesem publicznym w dziedzinie zdrowia publicznego, takich jak
        ochrona przed poważnymi transgranicznymi zagrożeniami zdrowotnymi na
        podstawie prawa państwa członkowskiego. Przetwarzanie danych dotyczących
        stanu zdrowia jest konieczne do korzystania z pełnych funkcjonalności
        ProteGO Safe (w tym samooceny ryzyka infekcji wirusem SARS-CoV-2,
        stworzonej na podstawie kwestionariusza WHO).
      </ListItem>
      <ListItem>
        Administrator danych przestrzega następujących zasad Przetwarzania
        Danych Osobowych:
        <ListNumber>
          <ListItem>
            wdraża odpowiednie środki techniczne i organizacyjne, aby
            przetwarzanie odbywało się zgodnie z przepisami o ochronie Danych
            Osobowych i aby móc to wykazać;
          </ListItem>
          <ListItem>
            utrwala zbierane Dane Osobowe wyłącznie na takich nośnikach
            informacji, które są zabezpieczone przed dostępem osób trzecich;
          </ListItem>
          <ListItem>
            wykonuje nadzór nad bezpieczeństwem danych przez cały okres ich
            posiadania w sposób zapewniający w szczególności ochronę przed
            dostępem osób nieuprawnionych, uszkodzeniem, zniszczeniem lub
            utratą;
          </ListItem>
          <ListItem>
            przekazuje dane uprawnionym podmiotom wyłącznie na podstawie
            obowiązujących przepisów prawa;
          </ListItem>
          <ListItem>zachowuje poufność Danych Osobowych;</ListItem>
          <ListItem>
            zapewnia osobom, których dane dotyczą, realizację ich praw
            wynikających z przepisów prawa.
          </ListItem>
        </ListNumber>
      </ListItem>
      <ListItem>
        Administrator danych może przetwarzać następujące Dane Osobowe
        (kategorie Danych Osobowych): identyfikator Urządzenia Użytkownika,
        nazwa Użytkownika (imię), dane dotyczące zdrowia, płeć, wiek, dane
        dotyczące palenia papierosów i inne, które Użytkownik zdecyduje się
        dobrowolnie wprowadzić do funkcjonalności Dziennik Zdrowia w ProteGO
        Safe.
      </ListItem>
      <ListItem>
        Podanie Danych Osobowych, o których mowa w ust. 5 niniejszego paragrafu,
        jest dobrowolne, lecz może warunkować korzystanie z pełnych
        funkcjonalności ProteGO Safe.
      </ListItem>
      <ListItem>
        Ponadto przetwarzane będą wszelkie Dane Osobowe dobrowolnie przekazane
        przez Użytkownika w związku z jakąkolwiek formą kontaktu z
        Administratorem.
      </ListItem>
      <ListItem>
        Odbiorcami zanonimizowanych danych i informacji z ProteGO Safe mogą być:
        <ListNumber>
          <ListItem>
            podmioty, które współpracują z Administratorem Danych w celu rozwoju
            i utrzymania ProteGO Safe:
            <ListNumber>
              <ListItem>
                Minister Cyfryzacji z siedzibą w Warszawie, ul. Królewska 27, 00
                – 060 Warszawa, e-mail: <Email>mc@mc.gov.pl</Email>{' '}
                (Administrator Systemu);
              </ListItem>
              <ListItem>
                TYTANI24 Spółka z ograniczoną odpowiedzialnością z siedzibą we
                Wrocławiu, ul. Ząbkowicka 55, 50 – 511 Wrocław (adres biura: ul.
                Kościerzyńska 32A, Wrocław, 51 – 410), wpisana do rejestru
                przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez
                Sąd Rejonowy we Wrocławiu, VI Wydział Gospodarczy Krajowego
                Rejestru Sądowego, pod numerem KRS 0000725465, REGON 369879064,
                NIP 8992843182, o kapitale zakładowym opłaconym w całości w
                wysokości 20 000,00 zł;
              </ListItem>
            </ListNumber>
          </ListItem>
        </ListNumber>
      </ListItem>
      <ListItem>
        Podmiot, który dostarcza narzędzie umożliwiające samoocenę ryzyka
        zarażenia <Url value="https://www.gov.pl/web/koronawirus">COVID-19</Url>{' '}
        : Infermedica Sp. z o.o. z siedzibą we Wrocławiu, Plac Solny 14/3,
        50-062 Wrocław, wpisana do rejestru przedsiębiorców Krajowego Rejestru
        Sądowego prowadzonego przez Sąd Rejonowy we Wrocławiu, VI Wydział
        Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000429183,
        REGON 021889810, NIP 8971782877 (polityka prywatności Infermedica:{' '}
        <Url value="https://infermedica.com/privacy-policy">
          infermedica.com/privacy-policy
        </Url>
        , informacje o Usłudze Triażu:{' '}
        <Url value="https://developer.infermedica.com/docs/covid-19#triage">
          covid-19#triage
        </Url>
        );
      </ListItem>
      <ListItem>
        Podmiot dostarczający infrastrukturę umożliwiającą pobranie i
        aktualizowanie ProteGO Safe: Google Ireland Limited, Gordon House,
        Barrow Street, Dublin 4, Irlandia VAT IE6388047V (
        <Url value="https://firebase.google.com/support/privacy">
          usługa Google Firebase
        </Url>
        ).
      </ListItem>
      <ListItem>
        Podmiot dostarczający w przyszłości dodatkowe funkcjonalności: Centrum
        Systemów Informacyjnych Ochrony Zdrowia z siedzibą w Warszawie, ul.
        Stanisława Dubois 5a, 00-184 Warszawa, e-mail:{' '}
        <Email>biuro@csioz.gov.pl</Email>;
      </ListItem>
      <ListItem>
        Minister Zdrowia z siedzibą w Warszawie, ul. Miodowa 15. 00-952
        Warszawa, NIP 5251918554, Regon 000287987.
      </ListItem>
      <ListItem>
        Przetwarzane Dane Osobowe nie są udostępniane Odbiorcom Danych w formie,
        która pozwalałaby na identyfikację.
      </ListItem>
      <ListItem>
        Dane Osobowe będą przechowywane nie dłużej niż trwa korzystanie z
        ProteGO Safe, a także nie dłużej niż jest to wymagane przepisami prawa i
        nie dłużej niż jest to niezbędne do osiągnięcia celu przetwarzania. Po
        zaprzestaniu korzystania z ProteGO Safe Dane Osobowe zostaną usunięte
        wraz z Aplikacją.
      </ListItem>
      <ListItem>
        Dane Osobowe nie będą przekazywane poza Europejski Obszar Gospodarczy.
      </ListItem>
      <ListItem>
        Dane Osobowe nie będą poddawane profilowaniu. Administrator nie
        podejmuje względem Użytkownika decyzji w sposób zautomatyzowany.
      </ListItem>
    </ListNumber>
    <Annotation>§4.</Annotation>
    <Title>Prawa Użytkowników</Title>
    <ListNumber>
      <ListItem>
        Osobom, których dane dotyczą, przysługuje:
        <ListNumber>
          <ListItem>
            na podstawie art. 15 RODO prawo dostępu do Danych Osobowych;
          </ListItem>
          <ListItem>
            na podstawie art. 16 RODO prawo do sprostowania Danych Osobowych;
          </ListItem>
          <ListItem>
            na podstawie art. 17 RODO prawo do usunięcia Danych Osobowych;
          </ListItem>
          <ListItem>
            na podstawie art. 18 RODO prawo żądania od Administratora
            ograniczenia Przetwarzania Danych Osobowych z zastrzeżeniem
            przypadków, o których mowa w art. 18 ust. 2 RODO;
          </ListItem>
          <ListItem>
            prawo do przenoszenia Danych Osobowych, o którym mowa w art. 20
            RODO;
          </ListItem>
          <ListItem>
            na podstawie art. 21 RODO prawo sprzeciwu wobec Przetwarzania Danych
            Osobowych.
          </ListItem>
        </ListNumber>
      </ListItem>
      <ListItem>
        W celu realizacji praw wskazanych w ust. 1, należy skorzystać z
        odpowiednich funkcjonalności ProteGO Safe.
      </ListItem>
      <ListItem>
        Osoba, której dane dotyczą, ma prawo wniesienia skargi do Prezesa Urzędu
        Ochrony Danych Osobowych, jeżeli uzna, że Przetwarzanie jego Danych
        Osobowych narusza przepisy RODO lub powszechnie obowiązujące przepisy.
      </ListItem>
    </ListNumber>
    <Annotation>§5.</Annotation>
    <Title>Postanowienia końcowe</Title>
    <ListNumber>
      <ListItem>
        W ProteGO Safe mogą pojawiać się linki do innych stron internetowych.
        Takie strony internetowe działają niezależnie od Administratora i nie są
        w żaden sposób przez niego nadzorowane. Strony te mogą posiadać własne
        polityki prywatności oraz regulaminy, z którymi zalecamy się zapoznać.
      </ListItem>
      <ListItem>
        Administrator zastrzega sobie prawo zmiany Polityki Prywatności poprzez
        opublikowanie nowej Polityki Prywatności na stronie ProteGO Safe.
      </ListItem>
      <ListItem>
        O wszelkich zmianach Polityki Prywatności Administrator będzie
        informować z wyprzedzeniem.
      </ListItem>
    </ListNumber>
  </>
);

export default PrivacyPolicyContent;
